import {DataFieldType} from '@Components';
import {DateTimeService} from '@Services';

const PERCENT_REGEX = /^-?\d+(\.\d+)?%$/;

export function compareValues(
    aName: string | number,
    bName: string | number,
    dataFieldType?: DataFieldType
): number {
    if (dataFieldType === DataFieldType.Number) {
        return Number(aName) - Number(bName);
    }

    if (typeof aName === 'number' && typeof bName === 'number') {
        return aName - bName;
    }

    if (typeof aName === 'string' && typeof bName === 'string') {
        const aIsPercent = PERCENT_REGEX.test(aName.trim());
        const bIsPercent = PERCENT_REGEX.test(bName.trim());

        if (aIsPercent && bIsPercent) {
            return parseFloat(aName) - parseFloat(bName);
        }

        const aDate = DateTimeService.parseAnyUiDate(aName);
        const bDate = DateTimeService.parseAnyUiDate(bName);

        if (aDate && bDate) {
            return aDate.getTime() - bDate.getTime();
        }

        return aName.localeCompare(bName);
    }

    return 0;
}